module.exports = __webpack_public_path__ + "img/20.8f6b72b1.jpg";